export default "__VITE_ASSET__CtRRlpMX__"